export default __webpack_public_path__ + "static/media/mint-2.f65684e8.mp3";